module.exports = __webpack_public_path__ + "img/info-icon.c8e0e29a.svg";